import * as React from "react";
const SvgSort = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M7.768 2.121c-.003 0-.998.994-2.211 2.207L3.352 6.533l.53.533.534.532 1.297-1.295 1.295-1.297.002 8.406.004 8.404.75.002.752.002V4.996l1.3 1.3 1.301 1.302.533-.532.532-.533-2.205-2.205C8.763 3.115 7.77 2.121 7.767 2.121Zm7.716.059v16.824l-1.3-1.3-1.301-1.302-.531.532-.534.533 2.207 2.209 2.21 2.207 2.206-2.207 2.21-2.21-.534-.532-.533-.532-1.295 1.295-1.297 1.297-.002-8.406-.002-8.404-.752-.002z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgSort;
